import type { PageDetailResponse } from "contracts/api/dashboard/page-detail.responses";
import { api } from "../../store/api";
import { AuthenticatedImage } from "../../ui/AuthenticatedImage";
import { formatDate } from "../../ui/format";

export function ScreenshotFigure(props: {
  page: PageDetailResponse["page"];
  shot: PageDetailResponse["screenshots"][number];
  websiteId: string;
}) {
  const source = () =>
    api.screenshotPath(props.websiteId, props.page.id, props.shot.id);
  return (
    <figure>
      <AuthenticatedImage
        path={source()}
        alt={`${props.shot.device} screenshot of ${props.page.path}`}
      />
      <figcaption class="mono">
        {props.shot.device} / {props.shot.byteLength}b /{" "}
        {formatDate(props.shot.capturedAt)}
      </figcaption>
    </figure>
  );
}
